import axios from 'axios';

/**
 * Wallet service — calls sat-agents WalletController at /api/agent/wallet
 * Proxied to localhost:8090 via setupProxy.js
 */

const agentBaseUrl = process.env.REACT_APP_SAT_AGENTS_URL || '';

const agentApi = axios.create({
    baseURL: `${agentBaseUrl}/api/agent`,
    headers: { 'Content-Type': 'application/json' },
});

// Attach Bearer token from localStorage
agentApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    return config;
});

export const walletService = {
    /**
     * GET /api/agent/wallet/{userId}
     * Returns { userId, balanceCredits, negativeLimitCredits, status }
     */
    getWallet: (userId) => agentApi.get(`/wallet/${userId}`).then((r) => r.data),

    /**
     * GET /api/agent/wallet/{userId}/can-spend
     * Returns { allowed, reason, currentBalance }
     */
    canSpend: (userId) => agentApi.get(`/wallet/${userId}/can-spend`).then((r) => r.data),

    /**
     * POST /api/agent/wallet/credit
     * Body: { userId, credits, paymentId }
     * Returns updated wallet
     */
    creditWallet: (userId, credits, paymentId) =>
        agentApi.post('/wallet/credit', { userId, credits, paymentId }).then((r) => r.data),
};
